import styled from "styled-components";
import { Column, Row } from "components/styles";


export const CapacityFields = styled(Column).attrs({
	width: "unset", 
	gap: "5px"
})`
	& [data-field="text"] {
		width: 180px;
		min-width: unset;
	}
`;
export const Container = styled(Column)`
    padding-right: 10px;
	width: 100%;
	&.custom-scrollbar {
		max-height: 65vh;
		@media (max-height: 650px) {
			max-height: 50vh;
		}
	}
	&.custom-scrollbar [data-field="text-search"] {
		max-width: 300px;
	}
	& [data-field="text-search"] {
		flex-grow: 2;
	}
	& ${CapacityFields} {
		flex-grow: 1;
		& ${Row} {
			flex-grow: 1;
		}
		[data-field="text"] {
			flex-grow: 1;
		}
	}
`;
export const HeaderFields = styled(Row)`
	width: 100%; 
	justify-content: flex-start;
	& [data-field="text"],
	& [data-field="select"] {
		flex-grow: 1;
	}
`;
export const AddressFields = styled(Row)`
	width: 100%;
	align-items: flex-start;
	& > * {
		flex: 1;
	}
`;